<form [formGroup]="saveForm" (ngSubmit)="saveToDB()">
  <h2 mat-dialog-title>บันทึกข้อมูลอ้อยไม่ได้คุณภาพ</h2>

  <input type="hidden" formControlName="production_year_id">
  <input type="hidden" formControlName="user_id">
  <input type="hidden" formControlName="doc_status">

  <mat-form-field class="full-width" appearance="fill">
    <mat-label>เลขใบคิว</mat-label>
    <input matInput ([ngModel])="data.truck_q" formControlName="truck_q" placeholder="" readonly />
  </mat-form-field>

  <mat-form-field class="full-width" appearance="fill">
    <mat-label>!!ตรวจพบ</mat-label>
    <!-- <mat-select formControlName="contaminants" [(ngModel)]="selectedCategories" multiple>
      @for (category of categories; track category) {
        <mat-option [value]="category">{{category}}</mat-option>
      }
    </mat-select> -->
    <mat-select formControlName="contaminants" [(ngModel)]="selectedCategories" multiple>
      <mat-option *ngFor="let category of categories" [value]="category">
        {{ category }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="full-width" appearance="fill">
    <mat-label>บันทึกเพิ่มเติม</mat-label>
    <textarea matInput formControlName="details" placeholder="Enter Details"></textarea>
  </mat-form-field>

  <!-- File Input -->
  <input type="file" (change)="onFileSelected($event)" />
  <img *ngIf="imagePreview" [src]="imagePreview" alt="Preview" width="100" />

  <div class="row">
    <div class="col-2">
      <button type="button" [disabled]="!selectedFile" (click)="uploadFile()" mat-icon-button aria-label="">
        <mat-icon>upload</mat-icon>
      </button>
      <!-- <button (click)="uploadPhoto()" class="w3-margin" mat-raised-button color="primary" [disabled]="!selectedFiles">
        อัพโหลดภาพ
      </button> -->
    </div>
    <div class="col-10">
      <!-- Progress Bar -->
      <!-- <mat-progress-bar *ngIf="currentFileUpload !== null" mode="determinate" [value]="percentage"></mat-progress-bar> -->

      <div *ngIf="uploadProgress >= 0" class="progress mt-2 mb-2">
        <div class="progress-bar progress-bar-info" role="progressbar"
          attr.aria-valuenow="{{ uploadProgress }}" aria-valuemin="0" aria-valuemax="100"
          [ngStyle]="{ width: uploadProgress + '%' }">
          {{ uploadProgress }}%
        </div>
      </div>

    </div>
  </div>


  <mat-form-field class="full-width" appearance="fill">
    <mat-label>ที่อยู่ไฟล์ภาพ</mat-label>
    <input matInput formControlName="imageUrl" placeholder="imgUrl" />
  </mat-form-field>

  <div mat-dialog-actions>
    <button mat-raised-button color="primary" type="submit" [disabled]="saveForm.invalid || isUploading">
      Upload/save
    </button>
    <button mat-raised-button mat-dialog-close>Cancel</button>
  </div>
</form>
